import { BASE_URL } from "../../data/BaseUrl";

export const fetchParentBlogCategories = async (filters, token) => {
  let url = "blog/main_category";

  const filteredParams = Object.entries(filters)
    .filter(([_, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    const responseJson = await response.json();

    return responseJson;
  } catch (error) {
    console.log("fetchParentBlogCategories=> ", error);
    throw error;
  }
};

export const fetchBlogCategories = async (filters, token) => {
  let url = "blog/category";

  const filteredParams = Object.entries(filters)
    .filter(([_, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    const responseJson = await response.json();

    return responseJson;
  } catch (error) {
    console.log("fetchBlogCategories=> ", error);
    throw error;
  }
};

export const fetchBlogs = async (filters, token) => {
  let url = "blog/article";

  const filteredParams = Object.entries(filters)
    .filter(([_, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    const responseJson = response.json();

    return responseJson;
  } catch (error) {
    console.log("fetchBlogs=> ", error);
    return error;
  }
};

export const fetchAIGeneratedBlog = async (filters, token) => {
  let url = "blog/ai-blogs";

  const filteredParams = Object.entries(filters)
    .filter(([_, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    const responseJson = response.json();

    return responseJson;
  } catch (error) {
    console.log("fetchAIGeneratedBlog=> ", error);
    return error;
  }
};

export const fetchBroadcastTemplates = async (filters, token) => {
  let url = "wati/get_email_template";

  const filteredParams = Object.entries(filters)
    .filter(([_, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    const responseJson = response.json();

    return responseJson;
  } catch (error) {
    console.log("fetchBroadcastTemplates=> ", error);
    return error;
  }
};

export const fetchBroadcastWPTemplates = async (filters, token) => {
  let url = "wati/broadcast/template/wa";

  const filteredParams = Object.entries(filters)
    .filter(([_, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    const responseJson = response.json();

    return responseJson;
  } catch (error) {
    console.log("fetchBroadcastWPTemplates=> ", error);
    return error;
  }
};

export const fetchBroadcastVariables = async (filters, token) => {
  let url = "wati/broadcast/variable";

  const filteredParams = Object.entries(filters)
    .filter(([_, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    const responseJson = response.json();

    return responseJson;
  } catch (error) {
    console.log("fetchBroadcastVariables=> ", error);
    return error;
  }
};

export const fetchSendyLists = async (filters, token) => {
  let url = "listmonk/lists";

  const filteredParams = Object.entries(filters)
    .filter(([_, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    const responseJson = response.json();

    console.log("responseJson===>", responseJson);

    return responseJson;
  } catch (error) {
    console.log("fetchSendyLists=> ", error);
    return error;
  }
};

export const fetchBroadcastListings = async (filters, token) => {
  let url = "wati/notification_logs";

  const filteredParams = Object.entries(filters)
    .filter(([_, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    const responseJson = await response.json();

    return responseJson;
  } catch (error) {
    console.log("fetchBroadcastListings=> ", error);
    return error;
  }
};

export const fetchBroadcastLogs = async (filters, token) => {
  let url = "wati/broadcast";

  const filteredParams = Object.entries(filters)
    .filter(([_, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    const responseJson = await response.json();

    return responseJson;
  } catch (error) {
    console.log("fetchBroadcastLogs=> ", error);
    return error;
  }
};

export const fetchBCAScheduler = async (filters, token) => {
  let url = "wati/schedule_broadcast";

  const filteredParams = Object.entries(filters)
    .filter(([_, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    const responseJson = await response.json();

    return responseJson;
  } catch (error) {
    console.log("fetchBCAScheduler=> ", error);
    return error;
  }
};

export const fetchBCASchedulerBroadcastLogs = async (filters, token) => {
  let url = "wati/schedule_broadcast_log";

  const filteredParams = Object.entries(filters)
    .filter(([_, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    const responseJson = await response.json();

    return responseJson;
  } catch (error) {
    console.log("fetchBCASchedulerBroadcastLogs=> ", error);
    return error;
  }
};
